import { render, staticRenderFns } from "./OrderUpdateDialog.vue?vue&type=template&id=04be036e"
import script from "./OrderUpdateDialog.vue?vue&type=script&lang=js"
export * from "./OrderUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports